import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "../store";
import dooglieLogo from "../images/login/DOL_Standalone.svg";
import "../styles/ui.css";

/**
 * What a signed-in user sees when their org hasn't given them a seat.
 *
 * A seat is the entitlement to use Dooglie, enforced server-side — every gated
 * endpoint returns 403 `seat_required` for this user. Without this screen they'd
 * see a working app that failed on every action, so we replace the app entirely
 * and say who can fix it. They are still authenticated: this is not a login
 * problem and must never be presented as one.
 *
 * Org admins keep a route through to Users, because that page is exempt from the
 * gate precisely so an admin can grant themselves the seat they're missing.
 */
const NoSeat: React.FC = () => {
  const isOrgAdmin = useSelector((s: RootState) => s.user.is_org_admin);

  return (
    <div className="dg-noseat">
      <div className="dg-noseat-card">
        <img src={dooglieLogo} alt="Dooglie" className="dg-noseat-logo" />
        <div className="dg-noseat-title">You don't have a Dooglie seat</div>
        <div className="dg-noseat-body">
          Your organisation hasn't given you one yet. An administrator can assign
          you a seat from the Users page in Dooglie, and you'll have access as
          soon as they do.
        </div>
        {isOrgAdmin && (
          <a className="dg-btn dg-btn-primary" href="/settings?tab=users">
            Go to Users
          </a>
        )}
      </div>
    </div>
  );
};

export default NoSeat;
